// extracted by mini-css-extract-plugin
export default {"focus_cover":"FocusCover_focus_cover__WieBU","hide":"FocusCover_hide__nxXFp","background":"FocusCover_background__j7R+K"};